import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo, WhatsAppIcon } from "./Logo";
import { CONTACT, waLink, mailtoLink, WHATSAPP_ENABLED, PHONE_ENABLED, LEGAL } from "../../config";
import { track } from "../../lib/tracking";
import { openPreferences } from "../../lib/consent";
import { ZONE_LINKS, SERVICE_LINKS } from "../../data/seoPages";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-navy-deep text-white/80">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Logo markColor="#fff" textColor="#fff" />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
            Piccoli lavori edili, tinteggiature, rifacimento bagni e interventi rapidi
            in tutta {CONTACT.area}. Professionalità, precisione e comunicazione semplice.
          </p>
          {WHATSAPP_ENABLED ? (
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              onClick={() => track.whatsappClick("footer")}
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-semibold text-white hover:bg-[#1ebe5b] transition-colors"
            >
              <WhatsAppIcon size={18} /> Scrivici su WhatsApp
            </a>
          ) : (
            <a
              href="#preventivo"
              data-testid="footer-preventivo"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand-orange px-5 py-3 text-sm font-semibold text-white hover:bg-brand-orange-dark transition-colors"
            >
              Richiedi Preventivo Gratuito
            </a>
          )}
        </div>

        <div>
          <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider">Servizi</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {["Imbiancatura e tinteggiature", "Rifacimento bagni", "Piastrellatura", "Muratura e pareti", "Cartongesso", "Riparazioni e manutenzioni"].map((s) => (
              <li key={s}><a href="#servizi" className="hover:text-white transition-colors">{s}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider">Contatti</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-center gap-2"><MapPin size={16} className="text-brand-orange" /> {CONTACT.area}</li>
            <li>
              <a href={mailtoLink()} data-testid="footer-email" className="flex items-center gap-2 hover:text-white transition-colors">
                <Mail size={16} className="text-brand-orange" /> {CONTACT.email}
              </a>
            </li>
            {PHONE_ENABLED && (
              <li>
                <a href={`tel:${CONTACT.phoneNumber}`} data-testid="footer-phone" onClick={() => track.phoneClick("footer")} className="flex items-center gap-2 hover:text-white transition-colors">
                  <Phone size={16} className="text-brand-orange" /> {CONTACT.phoneDisplay}
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-10 grid gap-8 sm:grid-cols-2">
          <div>
            <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider">Zone servite a Roma</h4>
            <ul className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
              {ZONE_LINKS.map((z) => (
                <li key={z.slug}>
                  <Link to={`/${z.slug}`} data-testid={`footer-zone-${z.slug}`} className="hover:text-white transition-colors">{z.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider">Servizi a Roma</h4>
            <ul className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
              {SERVICE_LINKS.map((s) => (
                <li key={s.slug}>
                  <Link to={`/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="hover:text-white transition-colors">{s.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-5 flex flex-col gap-4 text-xs text-white/45">
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/cookie-policy" data-testid="footer-cookie-policy" className="hover:text-white transition-colors">Cookie Policy</Link>
            <button type="button" onClick={openPreferences} data-testid="footer-cookie-prefs" className="hover:text-white transition-colors">Preferenze cookie</button>
          </nav>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p>© {year} {CONTACT.businessName} · {LEGAL.owner}. Tutti i diritti riservati.</p>
            <p>Muratore Roma · Imbianchino Roma · Rifacimento bagno Roma · Cartongesso Roma</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
